<template>
  <div class="form-container" :class="{ isMobile: isMobile }">
    <div class="auth-form">
      <h1 class="auth-title mb-6">Logowanie do c-KOB</h1>
      <label for="login-by-gov.pl" class="label mb-3">
        Jesteś osobą fizyczną?
      </label>
      <v-btn
        rounded
        large
        color="primary"
        id="login-by-gov.pl"
        elevation="0"
        @click="loginWK"
      >
        {{ btnText }}
      </v-btn>

      <h2 class="label mb-5 mt-10">
        Masz już konto? <br />Możesz zalogować się przez e-mail i hasło.
      </h2>

      <!-- start -->
      <validation-observer ref="observer">
        <form method="post" :action="action" id="form-login-by-email">
          <ValidationProvider
            v-slot="{ errors }"
            rules="required|email"
            vid="email"
            name="adres e-mail"
          >
            <v-text-field
              v-model="username"
              title="Uzupełnij pole"
              label="E-mail"
              placeholder="Adres e-mail"
              name="username"
              outlined
              persistent-placeholder
              :error-messages="errors"
              background-color="white"
              autocomplete="email"
              id="login-email"
            ></v-text-field>
          </ValidationProvider>

          <v-text-field
            class="v-input--is-label-active"
            title="Uzupełnij pole"
            name="password"
            label="Hasło"
            placeholder="Hasło"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPassword ? 'text' : 'password'"
            @click:append="showPassword = !showPassword"
            outlined
            persistent-placeholder
            background-color="white"
            id="login-password"
          >
          </v-text-field>

          <div class="divider my-4"></div>
          <h2 class="label mb-6">
            Jesteś pracownikiem administracji? <br />
            Zaloguj się przez e-mail i hasło.
          </h2>

          <LoginAlerts
            :show="show"
            :type="color"
            :msg="text"
            @close="show = false"
            dismissible
          />

          <div class="actions">
            <div class="actions_links">
              <LibBtnSimple
                color="primary"
                text="Nie pamiętasz hasła?"
                rounded
                underline
                title="Kliknij, aby ustawić nowe hasło do konta użytkownika Cyfrowej Książki Obiektu Budowlanego"
                :to="{ name: 'RemindPassword' }"
              />
              <v-btn
                title="Kliknij, aby zalogować się do Cyfrowej Książki Obiektu Budowlanego"
                rounded
                large
                color="primary"
                elevation="0"
                class="ml-2"
                @click="onSubmit"
              >
                Zaloguj się
              </v-btn>
            </div>
          </div>
        </form>
      </validation-observer>

      <dialog-yes-no :dialog="exitiedDialog" />
      <form id="wk" ref="wk" method="post" :action="action" autocomplete="off">
        <input
          hidden
          :value="wkt"
          name="username"
          id="login-token"
          autocomplete="off"
        />
      </form>
      <!-- end -->
    </div>
  </div>
</template>
<script>
import DialogYesNo from "@/components/DialogYesNo.vue";
import LibBtnSimple from "@/components/library/common/LibBtnSimple.vue";
import LoginAlerts from "../components/LoginAlerts.vue";
import {
  ValidationObserver,
  ValidationProvider,
  setInteractionMode
} from "vee-validate";

import { required, email } from "vee-validate/dist/rules";
import { extend } from "vee-validate";

setInteractionMode("lazy");
extend("required", required);
extend("email", {
  ...email,
  message: "Wprowadź poprawny adres e-mail"
});

const errorsMsg = {
  "bad-credentials": `Wystąpił błąd logowania związany z&nbsp;niepoprawnym adresem e-mail lub błędnym hasłem. Sprawdź poprawność danych do logowania lub skontaktuj się z&nbsp;administratorem.`,
  locked: "Twoje konto jest zablokowane. Skontaktuj się z&nbsp;administratorem.",
  disabled: "Na podany adres e-mail wysłaliśmy wiadomość z linkiem aktywacyjnym. Kliknij link, aby aktywować konto i dokończyć rejestrację."
};

export default {
  name: "Login",
  components: {
    DialogYesNo,
    LoginAlerts,
    LibBtnSimple,
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      action: process.env.VUE_APP_AUTH_REST_URL + "/login",
      text: "Niepoprawne dane logowania",
      color: "error",
      show: false,
      username: "",
      forgotPasswordDisabled: false,
      wkt: null,
      wktSessionId: null,
      exitiedDialog: {
        show: false,
        title: "Hasło",
        text: "Ważność Twojego hasła do konta wygasła. Chcesz zmienić hasło?",
        callback: () => {
          this.$router.push({ name: "ChangingExpiredPassword" });
        }
      },
      showPassword: false
    };
  },
  props: {
    error: {
      type: String,
      default: undefined
    },
    msg: {
      type: String,
      default: undefined
    }
  },
  metaInfo: {
    title: "Logowanie do c-KOB"
  },
  computed: {
    isWk() {
      return process.env.VUE_APP_WK === "true";
    },
    btnText() {
      return this.isWk
        ? "Zaloguj się poprzez login.gov.pl"
        : "Zarejestruj się w wersji testowej";
    }
  },
  methods: {
    onSubmit() {
      this.$refs.observer?.validate().then((result) => {
        if (result) {
          document.getElementById("form-login-by-email")?.submit();
        }
      });
    },
    loginWK() {
      window.location = process.env.VUE_APP_WK_INIT_URL;
    },
    makeid(length) {
      var result = "";
      var characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength)
        );
      }
      return result;
    }
  },
  mounted() {
    if (this.$route.query.wk) {
      document.getElementById("wk").submit();
    }

    if (this.msg) {
      this.text = decodeURIComponent(this.msg);
      this.color = "error";
      this.show = true;
    }

    if (this.$route.query.error === "expired") {
      this.exitiedDialog.show = true;
    } else if (this.$route.query.error === null || this.$route.query.error) {
      this.text =
        errorsMsg[this.error] ||
        "Wystąpił błąd logowania. Sprawdź poprawność użytej metody logowania (wskazówka: być może powinieneś skorzystać z&nbsp;logowania za pośrednictwem Węzła Krajowego)";
      this.color = "error";
      this.show = true;
    }

    if (this.$route.query.wk_disabled) {
      this.text =
        "Logowanie za pomocą e-maila i hasła wygasło. Proszę ponownie zalogować się przez Węzeł Krajowy.";
      this.color = "error";
      this.show = true;
    }

    this.wktSessionId = this.makeid(5);
  },
  created() {
    if (this.$route.query.wk) this.wkt = this.$route.query.wk;
  }
};
</script>
